<template>
  <div class="listing pictureWallList smooth">

    <div id="wallSliderElement">

        <div v-on:click="pickItem(item)" :key="index" v-for="(item, index) in listData" class="item hoverFade">
          <div class="image"> 
             <img v-bind:src="imageUrl+'/'+item.image_path" />
          </div>
        </div>
    </div> <!-- flexslider-->

  </div>
</template>

<script>

export default {
  data: function(){
    return{
      imageUrl: window.apiHandler.getWGUrl(),
      ids: {},
    }
  },

  props: ['listData'],

  methods: {

    pickItem: function(item){

      var self = this;

      // Prompt to save if needed first
      self.promtSave(function(){

        // Start picturewall loading
        self.$store.commit('startLoading', 'pictureWall');

        // Update vuex state to pick pictureWall
        self.$store.commit('pictureWall', item);

        // Reset vuex state price
        self.$store.commit('resetPrice');

        // Init choseable articles
        self.$store.commit('initChosenArticles', self.$store.state.pictureWall.articles);

        // Clear current wall ID
        self.$store.commit('currentWallID', false)

        // Emit event that tells a new picture wall has been selected
        window.eventHub.$emit('newPictureWall', item);

        // Close loading
        self.$store.commit('stopLoading', 'pictureWall');


      },
      {
        checkPictureWall: true
      });

      self.trackEvent('picture wall step');

    },

    reset: function(){
      this.$store.commit('resetChosenArticles');
    },

  },

  mounted: function () {


  }

}
</script>

<style lang="scss">

.pictureWallList{
  height: 100%;

  #wallSliderElement{
    height: 100%;
    overflow: auto;
  }

  .item{
    width: 100%;
    text-align: center;
    padding: 20px 20px 0px 20px;

    &:first-of-type{
      padding-top: 0;
    };

    /* Tablet */
    @media screen and (max-width: 1024px) {
      padding: 15px;
    }

    /* Mobile */
    @media screen and (max-width: 812px) {
      padding: 7px;
    }


  }

  .image{
    width: 100%;
  }

  .name{
    text-align: center;
    font-size: 12px;
    font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
    text-transform: uppercase;
    font-weight: 500;
  }

  .slick-slide img{
    display: inline-block;
    max-height: 137px;
    max-width: 100%;
  }

}

</style>



// WEBPACK FOOTER //
// PicturewallList.vue?1bd6abfc